module.exports = __webpack_public_path__ + "static/matt-hardy-6ArTTluciuA-unsplash-69ba0671266d29e5626402d6afa7a5f8.jpg";